module.exports = __webpack_public_path__ + "img/amilss.81d47dea.png";